import React from 'react'
import { Component } from 'react';
import './styles/Step3Form.css'
import { withRouter } from 'react-router-dom';
import Pdf from "../../../../file/Termini e condizioni Rider.pdf"

class Step3Screen extends Component {
    handleChange = (e) => {
        this.props.onChange(e.target.id, e.target.value);
    }


    render() {
        return (
            <div className="driver-step-3">
                <h3>Modulo di richiesta - Step 2/2</h3>
                <h5 className="mt-4">Conto in cui ricevere i pagamenti</h5>
                <div className="form-group">
                    <label htmlFor="iban" className="required">IBAN</label>
                    <input className="form-control" type="text" id="iban" value={this.props.data.iban} required onChange={this.handleChange} />
                </div>
                <h5 className="mt-4">Dati di accesso alla piattaforma</h5>
                <div className="form-group">
                    <label htmlFor="email" className="required">Email</label>
                    <input className="form-control" type="email" id="email" value={this.props.data.email} required onChange={this.handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="phoneNumber" className="required">Numero di telefono</label>
                    <input className="form-control" type="text" id="phoneNumber" value={this.props.data.phoneNumber} required onChange={this.handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="password" className="required">Password</label>
                    <input className="form-control" minLength="8" type="password" id="password" value={this.props.data.password} required onChange={this.handleChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="passwordConfirm" className="required">Conferma password</label>
                    <input className="form-control" minLength="8" type="password" id="passwordConfirm" value={this.props.data.passwordConfirm} required onChange={this.handleChange} />
                </div>
                <div className="custom-control custom-checkbox my-2">
                    <input type="checkbox" className="custom-control-input" id="driverTerms" required />
                    <label className="custom-control-label mt-1" htmlFor="driverTerms">Accetto <a href={Pdf} target="_blank" rel="noopener noreferrer">i termini e le condizioni</a></label>
                </div>
            </div>
        );
    }
}


export default withRouter(Step3Screen);